import { render } from "./Output.vue?vue&type=template&id=38a66d06&scoped=true"
import script from "./Output.vue?vue&type=script&lang=js"
export * from "./Output.vue?vue&type=script&lang=js"

import "./Output.vue?vue&type=style&index=0&id=38a66d06&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38a66d06"]])

export default __exports__